var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import '@bit/smartworks.unity.unity-core/unity-multi-pane';
export default class UnityMultiPane extends Component {
    constructor() {
        super(...arguments);
        this.multiPaneRef = React.createRef();
        this.componentDidMount = () => {
            this.updateProperties();
        };
        this.componentDidUpdate = () => {
            this.updateProperties();
        };
        this.updateProperties = () => {
            const { props, multiPaneRef } = this;
            const unityMultiPane = multiPaneRef.current;
            const { panes, onClose, onCollapseChange, closeButton, collapseButton } = props;
            if (unityMultiPane) {
                unityMultiPane.onClose = onClose || (() => { });
                unityMultiPane.onCollapseChange = onCollapseChange || (() => { });
                unityMultiPane.panes = panes;
                if (closeButton)
                    unityMultiPane.closeButton = closeButton;
                if (collapseButton)
                    unityMultiPane.collapseButton = collapseButton;
            }
        };
    }
    render() {
        const _a = this.props, { panes = [], closeButton, collapseButton, labels, visiblePanes, collapsedPanes } = _a, otherProps = __rest(_a, ["panes", "closeButton", "collapseButton", "labels", "visiblePanes", "collapsedPanes"]);
        let multiPaneArgs = Object.assign({}, otherProps);
        if (closeButton)
            multiPaneArgs.closeButton = closeButton;
        if (collapseButton)
            multiPaneArgs.collapseButton = collapseButton;
        return (React.createElement("unity-multi-pane", Object.assign({ className: "ump-wrapper", ref: this.multiPaneRef, labels: JSON.stringify(labels), visiblePanes: JSON.stringify(visiblePanes), collapsedPanes: JSON.stringify(collapsedPanes) }, multiPaneArgs), panes.map(({ key, header, body, footer }) => {
            let slots = [];
            if (!!header)
                slots.push((React.createElement("div", { slot: `${key}::header`, key: `${key}-header`, style: { flex: 1, width: '100%', display: 'flex' } }, header)));
            slots.push((React.createElement("div", { slot: key, key: `${key}-body`, style: { flex: 1, width: '100%', display: 'flex' } }, body)));
            if (!!footer)
                slots.push((React.createElement("div", { slot: `${key}::footer`, key: `${key}-footer`, style: { flex: 1, width: '100%', display: 'flex' } }, footer)));
            return slots;
        })));
    }
}
